import "vite/modulepreload-polyfill";
import { BrowserAgent } from "@newrelic/browser-agent/loaders/browser-agent";
import { PostHogProvider } from "@posthog/react";
import posthog from "posthog-js";
import { StrictMode, startTransition } from "react";
import { hydrateRoot } from "react-dom/client";
import { HydratedRouter } from "react-router/dom";

import Config from "./Config";

new BrowserAgent({
	init: {
		distributed_tracing: {
			enabled: true,
		},
		performance: {
			capture_measures: true,
		},
		browser_consent_mode: {
			enabled: false,
		},
		privacy: {
			cookies_enabled: false,
		},
	},
	loader_config: {
		accountID: Config.NEW_RELIC_ACCOUNT_ID,
		trustKey: Config.NEW_RELIC_ACCOUNT_ID,
		agentID: Config.NEW_RELIC_AGENT_ID,
		licenseKey: Config.NEW_RELIC_LICENSE_KEY,
		applicationID: Config.NEW_RELIC_APP_ID,
	},
	info: {
		beacon: "bam.eu01.nr-data.net",
		errorBeacon: "bam.eu01.nr-data.net",
		licenseKey: Config.NEW_RELIC_LICENSE_KEY,
		applicationID: Config.NEW_RELIC_APP_ID,
		sa: 1,
	},
});

posthog.init(Config.POSTHOG_KEY, {
	api_host: Config.POSTHOG_API,
});

startTransition(() => {
	hydrateRoot(
		document,
		<PostHogProvider client={posthog}>
			<StrictMode>
				<HydratedRouter />
			</StrictMode>
		</PostHogProvider>,
	);
});
